import { render, staticRenderFns } from "./WorkerChannelEdit.vue?vue&type=template&id=33107ba1&"
import script from "./WorkerChannelEdit.vue?vue&type=script&lang=js&"
export * from "./WorkerChannelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports